const states = {
  interest: {
    value: "interest",
    label: "Funder interest",
    color: "inProgress",
    chartColor: "#7239ea",
    order: 1,
  },
  talks: {
    value: "talks",
    label: "In Talks",
    color: "inProgress",
    chartColor: "#7239ea",
    order: 2,
  },
  exclusive: {
    value: "exclusive",
    label: "Exclusive",
    color: "inProgress",
    chartColor: "#7239ea",
    order: 3,
  },
  partial: {
    value: "partial",
    label: "Partially closed",
    chartColor: "#7239ea",
    color: "done",
    order: 4,
  },
  closed: {
    value: "closed",
    label: "Closed successfully",
    chartColor: "#7239ea",
    color: "done",
    order: 5,
  },
  abandon: {
    value: "abandon",
    label: "Archived",
    color: "denied",
    order: 6,
  },
};

module.exports = states;
